module.exports = __webpack_public_path__ + "img/placeholder_image.f7cf59ec.png";